import axios from 'axios';
import {
  message,
} from 'ant-design-vue';
import router from '../router';
import store from '../store';

export default function defaultFetch() {
}

export async function fetch(options) {
  const instance = await axios.create({
    timeout: 1000 * 600, // 超时  (设定请求时长 30s)
    headers: {
      token: localStorage.getItem('token'),
    },
  });
  try {
    const result = await instance(options);
    if (result.code === 16003 || result.status === 401) {
      store.commit('clearLoginInfo');
      await router.push('/login');
      return result;
    }
    if (result.status === 200) {
      return result.data || {};
    }
    message.error(result.message, 2);
    return result || {};
  } catch (error) {
    const { response } = error;
    if (response !== undefined && response.status !== undefined) {
      if (response.status === 400) {
        message.error(response.data, 2);
        return null;
      }
      if (response.status === 500) {
        message.error('服务器异常，等待修复', 2);
        await router.push('/error');
      }
      if (response.status === 401) {
        message.error('登录异常，请重新登录', 2);
        await router.push('/login');
      }
    } else {
      message.error('服务器异常，等待修复', 2);
      await router.push('/error');
    }
    return null;
  }
}
